export default {
  INPUT_MAX_LENGTH: 3000,
}
